import User from './user.js'
import Lead from './lead.js'
import Contact from './contact.js'
import Deal from './deal.js'
import Task from './task.js'
import Note from './note.js'
import SMS from './sms.js'
import Email from './email.js'
import Upload from './upload.js'
import Appointment from './appointment.js'
import Communication from './communication.js'
import Setting from './setting.js'
import ProspectDeal from './prospect-deal.js'
import Call from './call.js'
import Model from './model.js'

const MODEL_MAP = {
	46: Setting,
	48: Communication,
	100: Lead,
	102: Contact,
	103: Deal,
	201: SMS,
	202: Note,
	203: Email,
	204: Upload,
	205: Appointment,
	206: Call,
	207: Task,
	51: ProspectDeal,
}

export default class Log {
	constructor(data, options = {}) {
		this.data = data

		const typeId =
			parseInt(options.modelType) === 4
				? parseInt(data?.belongs_type)
				: parseInt(options.modelType ?? data?.belongs_type)

		const ModelClass = MODEL_MAP[typeId] ?? Model

		this.model = new ModelClass(data, options)

		return this
	}

	timeline() {
		let breakdown = {}
		let db = JSON.parse(this.data.data_before)
		let da = JSON.parse(this.data.data_after)

		for (let dak in da) {
			if (this.model.tailIgnoreKeys().indexOf(dak) !== -1) continue

			let label = dak.replace(/_/g, ' ')

			breakdown[label] = {
				before: db[dak] != null ? (db[dak].formatted !== undefined ? db[dak].formatted : db[dak]) : null,
				after: da[dak] != null ? (da[dak].formatted !== undefined ? da[dak].formatted : da[dak]) : null,
			}
		}

		let icon = 'IconInfoCircle'

		if (this.model._logIcon) {
			icon = this.model._logIcon()
		}

		return {
			title: this.data.title,
			description: this.data.description,
			created_at: this.data.created_at,
			icon: icon,
			breakdown: breakdown,
			noLineKeys: this.model.tail.noLineKeys ? this.model.tail.noLineKeys() : [],
		}
	}
}

// export default class Log {
// 	constructor(data, options) {
// 		if (data == null) {
// 			return
// 		}

// 		// console.log(data)

// 		this.className = {
// 			46: Setting,
// 			48: Communication,
// 			100: Lead,
// 			102: Contact,
// 			103: Deal,
// 			201: SMS,
// 			202: Note,
// 			203: Email,
// 			204: Upload,
// 			205: Appointment,
// 			207: Task,
// 		}[parseInt(data.belongs_type)]

// 		if (this.className == undefined) {
// 			console.log('No class name for:', data)
// 			this.className = Model
// 			// return
// 		}

// 		// console.log(this)

// 		options.$log = this

// 		this.$help = options.$help
// 		this.title = data.title
// 		this.description = data.description
// 		this.createdBy = new User(data.created_by)
// 		this.before = new this.className(JSON.parse(data.data_before), options)
// 		this.after = new this.className(JSON.parse(data.data_after), options)
// 		this.afterCount = data.after != null ? Object.keys(JSON.parse(data.data_after)).length : 0

// 		this.logType = 'updated'
// 		this.dataKey = 'after'

// 		if (data.data_before == null || data.data_after == null) {
// 			this.logType = data.data_before == null ? 'created' : 'removed'

// 			if (this.logType == 'removed') {
// 				this.dataKey = 'before'
// 			}
// 		}

// 		this.setTimeline()

// 		return this
// 	}

// 	setTimeline() {
// 		this.log = {
// 			title: this.getTitle(),
// 			description: this.getDescription(),
// 			created_at: this.created_at,
// 			icon: this.before._logIcon ? this.before._logIcon() : 'IconInfoCircle',
// 			breakdown: this.getBreakdown(),
// 			noLineKeys: this.after.tail.noLineKeys ? this.after.tail.noLineKeys() : [],
// 		}
// 	}

// 	getTitle() {
// 		if (this.title != null) {
// 			return this.title
// 		}

// 		let title = this.createdBy.fullName()

// 		let an = ['a', 'e', 'i', 'o', 'u'].indexOf(this._me().trim()[0].toLowerCase()) == -1 ? 'a' : 'an'

// 		return title + ' ' + (this.after.tail.logType ? this.after.tail.logType(this.logType) : this.logType) + ' ' + an + ' ' + this._me()
// 	}

// 	getDescription() {
// 		if (this.description != null) {
// 			return this.description
// 		}

// 		let desc = this._me() + ' '
// 		let totalChanges = Object.keys(this[this.dataKey]).filter(
// 			(key) => this[this.dataKey].tailIgnoreKeys().indexOf(key) == -1 && this.after[key] != this.before[key],
// 		)

// 		if (totalChanges.length >= 2 && this.logType == 'updated') {
// 			// return 'Bulk changes made to ' + this._me() + ', expand for breakdown'
// 			return 'Bulk updates made'
// 		} else if (this.logType == 'created') {
// 			if (this.after.tail.createdDescription != undefined) {
// 				return this.after.tail.createdDescription()
// 			}
// 			return 'Initial ' + this._me()
// 		} else if (this.logType == 'removed') {
// 			if (this.before.tail.removedDescription != undefined) {
// 				return this.before.tail.removedDescription()
// 			}

// 			return this._me() + ' has been deleted'
// 		} else {
// 			// if (this.afterCount && this.after.tail.)
// 			//
// 			if (this.after.tail.updatedDescription != undefined && this.after.tail.updatedDescription[totalChanges[0]] != undefined) {
// 				return this.after.tail.updatedDescription[totalChanges[0]]()
// 			}

// 			let f = this[this.dataKey].format(totalChanges[0])
// 			// let s = this._me() + ' ' + f[0]
// 			let s = f[0]
// 			if (f[0] && this._me().toLowerCase() == f[0].toLowerCase()) {
// 				s = this._me() + ' '
// 			}

// 			if (this.after.tail.extra_keys != undefined) {
// 				for (let i in this.after.tail.extra_keys) {
// 					let a = this.after.tail.extra_keys[i]()
// 					let b = this.before.tail.extra_keys[i]()

// 					if (a == null && b == null) {
// 						continue
// 					}

// 					try {
// 						s = (a == null ? b[0] : a[0]) + ' '
// 						f = [b[1], a[1]]
// 					} catch (error) {
// 						console.log(this)
// 						console.log(a, b)
// 						console.error(error)
// 					}
// 					break
// 				}

// 				// return this.$help.capitalizeFirstLetter(s) + ' ' + (b[2] != undefined ? b[2] : 'changed to') + ' "' + a[1] + '"'
// 			}

// 			if (f[1] == null) {
// 				return this.$help.capitalizeFirstLetter(s) + ' was removed'
// 			}

// 			return this.$help.capitalizeFirstLetter(s) + ' ' + (f[2] != undefined ? f[2] : 'changed to') + ' ' + f[1] + ''
// 		}
// 	}

// 	getBreakdown() {
// 		let down = {}

// 		for (let i in this[this.dataKey]) {
// 			if (this[this.dataKey].tailIgnoreKeys().indexOf(i) !== -1) continue
// 			let a = this.after.format(i)
// 			let b = this.before.format(i)

// 			if (a == undefined || b == undefined) {
// 				console.log(a, b)
// 			}

// 			if ((this.logType == 'removed' && (b[1] == '' || b[1] == null)) || a[1] == b[1]) {
// 				continue
// 			}

// 			down[this.logType == 'removed' ? b[0] : a[0]] = {
// 				type: 'tail',
// 				before: b[1],
// 				after: a[1],
// 			}

// 			// if ((a[1] == b[1] && this.logType == 'updated') || (a[1] == undefined && this.logType == 'created')) {
// 			//     continue
// 			// }

// 			// down[b[0] == null ? a[0] : b[0]] = {
// 			//     type: 'tail',
// 			//     before: a[0] != b[0] ? null : b[1],
// 			//     after: a[1],
// 			// }
// 		}

// 		if (this.after.tail.extra_keys != undefined) {
// 			for (let i in this.after.tail.extra_keys) {
// 				let a = this.after.tail.extra_keys[i]()

// 				if (a == null) {
// 					continue
// 				}

// 				down[a[0]] = {
// 					type: 'tail',
// 					before: null,
// 					after: a[1],
// 				}
// 			}
// 		}

// 		return down
// 	}

// 	timeline(user) {
// 		return this.log
// 	}

// 	_me() {
// 		let draft = false,
// 			states = this.after.publishedStates || this.before.publishedStates

// 		let publishedStates = states ? this.after.publishedStates || this.before.publishedStates : ['', '']

// 		if (this.before.me != undefined && this.logType != 'created') {
// 			if (states && this.after.published_at != null) {
// 				draft = true
// 			}

// 			return (draft ? publishedStates[1] + ' ' : publishedStates[0] + ' ') + this.before.me()
// 		}

// 		if (this.after.me != undefined && this.logType == 'created') {
// 			if (states && (this.after.published_at == null || this.after.published_at == undefined)) {
// 				draft = true
// 			}

// 			return (draft ? publishedStates[0] + ' ' : '') + this.after.me()
// 		}

// 		// return (
// 		//     (draft ? 'draft ' : '') +
// 		//     this.className._routeKey.toLowerCase()
// 		// )
// 	}
// }
